import axios, { AxiosResponse } from 'axios';
import { TOKEN_HEADER_NAME, UNAUTHORIZED_STATUS } from 'src/constants/index';
import isString from 'lodash/isString';
import Cookies from 'universal-cookie';
import { UrlUtils } from 'src/utils/index';

const LOCAL_HOST = 'localhost';
const REDIRECT_FOR_UNAUTH_USER = 'https://suitejourneys.com/';
const ID_PARAM_LABEL = 'i';
const TEST_ID = 1;
const USER_BASE_URL = 'usr_base_url';
const PATHNAME_REQUEST_CANCEL_RESERVATION = '/request-cancel-reservation';
const PATHNAME_RESERVATION_CANCELLATION = '/reservation-cancellation';

export const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    if (
      error?.response?.status === UNAUTHORIZED_STATUS &&
      location.pathname !== PATHNAME_REQUEST_CANCEL_RESERVATION &&
      location.pathname !== PATHNAME_RESERVATION_CANCELLATION
    ) {
      let redirectUrl = new Cookies().get(USER_BASE_URL);
      redirectUrl =
        isString(redirectUrl) && redirectUrl.length > 0 ? redirectUrl : REDIRECT_FOR_UNAUTH_USER;

      location.replace(redirectUrl);
    }

    return Promise.reject(error);
  },
);

export const getHeaders = (): { headers: { [key: string]: string | number } } => {
  const { hostname, search } = location;
  const parsedParams = UrlUtils.getParsedParams(search);
  let parsedId;

  parsedParams.forEach(([key, value]) => {
    if (key === ID_PARAM_LABEL) {
      parsedId = value;
    }
  });

  const id = hostname === LOCAL_HOST ? TEST_ID : parsedId ? parsedId : '';

  return {
    headers: {
      [TOKEN_HEADER_NAME]: id,
    },
  };
};
